import { Star } from "lucide-react";

export function StarRating({ value = 5, size = "w-5 h-5", className = "" }) {
  return (
    <div
      className={`flex items-center gap-0.5 ${className}`}
      data-testid="star-rating"
      aria-label={`${value} out of 5 stars`}
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          className={`${size} ${i < value ? "fill-yellow-400 text-yellow-400" : "text-gray-300"}`}
          strokeWidth={1.5}
        />
      ))}
    </div>
  );
}
